import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import '../../../assests/css/checkbox.scss';


interface checkboxProps {
  selected: boolean,
  disable?: boolean,
  onClick: (selected: boolean) => void,
}

function Checkbox(props: checkboxProps):JSX.Element {
    const {selected, disable, onClick} = props;

    const [
      selectedEle,
      setSelectedEle,
    ] = useState<boolean>(false);

    useEffect(() => {
      setSelectedEle(selected);
    }, [
      selected,
    ]);

    const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (!e.currentTarget.classList.contains('disable')) {
        setSelectedEle(!selectedEle);
        onClick(!selectedEle);
      }
    };
  
    return (
        <div
            className={classNames('checkbox-selection', selectedEle ? 'selected' : '', disable ? 'disable' 
            : '')}
            onClick={handleOnClick}
          >
            <div className="checkbox-selection-icon"></div>
        </div>
    );
}

export default Checkbox;
